import { Box, Flex } from "@chakra-ui/react"
import TurboShipping from "@components/Product/TurboShipping"
import { OfferData } from "@type/product"

const StockStatus = ({ offer }: { offer: OfferData }) => {
  return (
    <Flex
      justifyContent={"space-between"}
      alignItems={"center"}
      mt={4}
    >
      <TurboShipping
        visibility={offer.deliveryLeadTime.maxValue <= 3 ? undefined : "hidden"}
      />
      {offer.inventoryLevel < 6 ? (
        <Box
          color={"orange.500"}
          fontWeight={"bold"}
          fontSize={"xl"}
        >
          {`Only ${offer.inventoryLevel} left`}
        </Box>
      ) : (
        <Box
          color={"green.500"}
          fontWeight={"bold"}
          fontSize={"xl"}
        >
          {"In Stock"}
        </Box>
      )}
    </Flex>
  )
}

export default StockStatus
